import React from 'react';
import { Link } from 'react-router-dom';
import { getRandomColor } from '../utils/colors';
import ScrollIndicator from './shared/ScrollIndicator';
import { useRandomLinkColors } from '../utils/useRandomLinkColors';
const BodyNotThingPage = () => {
  // Use our custom hook to apply random colors to all links
  useRandomLinkColors();
  const images = ['https://cdn.magicpatterns.com/uploads/icVCZYMAA2tusQbPqdqV5M/01_MorletMadeleine_NorisPinkSink.jpg', 'https://cdn.magicpatterns.com/uploads/6uqbpweqY7PCAtAXostxXe/02_MorletMadeleine_Hibiscus.jpg', 'https://cdn.magicpatterns.com/uploads/wZKJyxLmpRuqDzP6nbUBmq/03_MorletMadeleine_Bougainvillea_.jpg', 'https://cdn.magicpatterns.com/uploads/7fwMK1rCsWAPtYAgkr34WY/04_MorletMadeleine_JoeyAndRomy_.jpg', 'https://cdn.magicpatterns.com/uploads/1E4kC6F86C2TWXqbjbhc6d/05_MorletMadeleine_Haircut.jpg', 'https://cdn.magicpatterns.com/uploads/wxxPSBhjqK9BkgyP9LtHCC/06_MorletMadeleine_AnnabelsMother-In-Law.jpg', 'https://cdn.magicpatterns.com/uploads/fihfyVQ5HNMNt16uACdXmN/07_MorletMadeleine_RootSystems.jpg', 'https://cdn.magicpatterns.com/uploads/1ukHfe1LTW5eXqk2vqaph9/08_MorletMadeleine_TwoWhiteCars_.jpg', 'https://cdn.magicpatterns.com/uploads/eGWa1cReEQ9UvqqAkaP72v/09_MorletMadeleine_VirginiaPregnant_.jpg', 'https://cdn.magicpatterns.com/uploads/hm7Frps1eC9kxaPjB8ivcN/10_MorletMadeleine_SquashedPeach.jpg', 'https://cdn.magicpatterns.com/uploads/4YFwxwYqvw2irYSVnqRT5k/11_MorletMadeleine_CocoAndBlue_.jpg', 'https://cdn.magicpatterns.com/uploads/tNHaSmnVPSHdQa4tHVwKuC/12_MorletMadeleine_MarleyAndJosh.jpg', 'https://cdn.magicpatterns.com/uploads/41Jd48TwMd9JV57jQpj5Zk/13_MorletMadeleine_SnakeTattoo_.jpg', 'https://cdn.magicpatterns.com/uploads/dAwDcBvaAXXmiJ1MmGZzFZ/14_MorletMadeleine_Madonna.jpg', 'https://cdn.magicpatterns.com/uploads/cZn1PELbWu9Wy4B1KnMNDe/15_MorletMadeleine_Amanda,OonaAndCosimo.jpg', 'https://cdn.magicpatterns.com/uploads/64LegcV9MJicEab7ApvMhk/16_MorletMadeleine_Bebe.jpg', 'https://cdn.magicpatterns.com/uploads/gxHF94mLh48Qg8TbY45Ein/17_MorletMadeleine_TheChateau_.jpg', 'https://cdn.magicpatterns.com/uploads/pGvM5LcsGZrY4LNorGpNUT/18_MorletMadeleine_LookingUp.jpg'];
  // Create a varied spacing array to make the layout more editorial
  const getSpacing = index => {
    const spacings = [6, 12, 8, 16, 10, 14, 7, 12, 9, 16, 10, 14];
    return spacings[index % spacings.length];
  };
  // Create a varied height array for more visual interest
  const getHeight = index => {
    const heights = ['70vh', '65vh', '75vh', '68vh'];
    return heights[index % heights.length];
  };
  const getImagePosition = (index: number) => {
    if (index === 0) return '16vh';
    const positions = ['4vh', '20vh', '8vh', '24vh', '12vh', '28vh', '16vh'];
    return positions[index % positions.length];
  };
  const getImageSize = (index: number) => {
    if (index === 0) return '85vh';
    const sizes = ['80vh', '60vh', '75vh', '65vh', '85vh'];
    return sizes[index % sizes.length];
  };
  return <div className="min-h-screen bg-[#faf9f7] text-[#333333] font-serif" data-id="element-73" data-mp="2skkte4epb6d2">
      <header className="fixed top-0 w-full flex justify-end px-6 py-6 z-10 bg-[#faf9f7]" data-id="element-74" data-mp="2xj4igdolcy9n">
        <div className="flex space-x-6" data-id="element-75" data-mp="32gw8111rk8ao">
          <div className="text-base font-normal" data-id="element-76" data-mp="32f325nyz5s3q">
            <Link to="/" className="transition-colors duration-200" onMouseEnter={e => {
            e.currentTarget.style.color = getRandomColor();
          }} onMouseLeave={e => {
            e.currentTarget.style.color = '#333333';
          }} data-id="element-77" data-mp="3785xo1nbbbmk">
              Madeleine Morlet
            </Link>
          </div>
          <div className="text-base font-normal" data-id="element-78" data-mp="3q70fxklziu7h">
            <Link to="/info" className="transition-colors duration-200" onMouseEnter={e => {
            e.currentTarget.style.color = getRandomColor();
          }} onMouseLeave={e => {
            e.currentTarget.style.color = '#333333';
          }} data-id="element-79" data-mp="3q4nw11wo29rs">
              Info
            </Link>
          </div>
        </div>
      </header>
      {/* Desktop Layout */}
      <div className="hidden md:block h-screen overflow-x-auto hide-scrollbar" data-id="element-80" data-mp="3vasqtghosdrq">
        <div className="flex min-w-max" data-id="element-81" data-mp="3r8eb359bdu4o">
          <div className="w-[33vw] pl-16 flex-shrink-0" style={{
          paddingTop: '24vh'
        }} data-id="element-82" data-mp="3r9fo3f9w4qp1">
            <div className="text-base max-w-[360px] pr-4" data-id="element-83" data-mp="2ykiiabmv8md6">
              <div data-id="element-84" data-mp="2ym3b9wtj7x8x">The Body Is Not A Thing (2020 to 2024)</div>
              <div className="text-sm leading-normal mt-4" data-id="element-85" data-mp="3ccox9uea8nb1">
                <em data-id="element-86" data-mp="37kyhh8wkt7c8">The Body Is Not A Thing</em> was conceived during lockdown.
                Like many women with young children, I experienced a loss of
                autonomy. In America, where I was living, the appetite for
                regressive politics was growing. I felt frustrated with the
                unrelatable and sanitised imagery that dominates mainstream
                representations of motherhood. In the year Roe V. Wade was
                overturned I travelled from my home, a small rural community in
                New England, to Los Angeles. I found myself drawn to the
                supposed duality of our sexual desire and our ability to give
                birth. I photographed actors, dancers, sex workers, and mothers.
                I thought I understood how to cast the female gaze. Later, as I
                reviewed the images, I found myself confronted by the enduring
                influence of the male gaze. I am forced to acknowledge the
                historical associations of female nudity, the provocation of
                shame, the influence of pornography, and internalised misogyny.
                Observing women intimately, interplaying sexuality and
                motherhood, is uncomfortable–but should it be?
              </div>
            </div>
          </div>
          <div className="flex items-start" style={{
          paddingTop: '16vh'
        }} data-id="element-87" data-mp="3anpf1nj80ufi">
            {images.map((image, index) => <div key={index} className="flex-shrink-0" style={{
            marginRight: index === images.length - 1 ? 0 : `${getSpacing(index)}rem`
          }} data-id="element-88" data-mp="30y5ri4kkcceb" data-mpi={index}>
                <img src={image} alt={`The Body Is Not A Thing - Image ${index + 1}`} className="w-auto object-contain" style={{
              height: getImageSize(index)
            }} data-id="element-89" data-mp="2qyf04braudig" />
              </div>)}
          </div>
        </div>
      </div>
      {/* Mobile Layout */}
      <div className="md:hidden pt-20 px-6" data-id="element-90" data-mp="g6m1v62ayev9">
        <div className="mb-6" data-id="element-91" data-mp="b9c85e7vrh1m">
          <div className="text-base mb-4" data-id="element-92" data-mp="ba589wcc38as">
            The Body Is Not A Thing (2020 to 2024)
          </div>
          <div className="text-sm leading-normal" data-id="element-93" data-mp="isuyk5jgeck8">
            <em data-id="element-94" data-mp="nrfy02qvss7m">The Body Is Not A Thing</em> was conceived during lockdown. Like
            many women with young children, I experienced a loss of autonomy. In
            America, where I was living, the appetite for regressive politics
            was growing. I felt frustrated with the unrelatable and sanitised
            imagery that dominates mainstream representations of motherhood. In
            the year Roe V. Wade was overturned I travelled from my home, a
            small rural community in New England, to Los Angeles. I found myself
            drawn to the supposed duality of our sexual desire and our ability
            to give birth. I photographed actors, dancers, sex workers, and
            mothers. I thought I understood how to cast the female gaze. Later,
            as I reviewed the images, I found myself confronted by the enduring
            influence of the male gaze. I am forced to acknowledge the
            historical associations of female nudity, the provocation of shame,
            the influence of pornography, and internalised misogyny. Observing
            women intimately, interplaying sexuality and motherhood, is
            uncomfortable–but should it be?
          </div>
        </div>
        <div className="w-full space-y-8" data-id="element-95" data-mp="2g8isfwwgbc07">
          {images.map((image, index) => <div key={index} className="w-full" data-id="element-96" data-mp="2tznkodxhp20i" data-mpi={index}>
              <img src={image} alt={`The Body Is Not A Thing - Image ${index + 1}`} className="w-full h-auto object-contain" data-id="element-97" data-mp="2pzwvgenm2ty3" />
            </div>)}
        </div>
      </div>
      <ScrollIndicator data-id="element-98" data-mp="2z1mkxexxnit8" />
      <style jsx data-id="element-99" data-mp="2yy8jqa109fnd">{`
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
        .hide-scrollbar {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </div>;
};
export default BodyNotThingPage;